import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import JobApplicationShowPageContainer from '@buyside/components/container/JobApplicationShowPage/jobApplicationShowPageContainer';

const JobApplicationsShowPageRoot: FC<{ jobApplicationId: string }> = ({ jobApplicationId }) => {
  return (
    <ErrorBoundary pageName="the job application">
      <JobApplicationShowPageContainer jobApplicationId={jobApplicationId} />
    </ErrorBoundary>
  );
};

export default JobApplicationsShowPageRoot;
